import { Component } from "solid-js";

import Styles from "bundle-text:../styles/_typeConnectCard.scss";
import { translations as t } from "../../../services/context";

interface BodyCardProps {
  title?: string;
  subtitle?: string;
  img?: string;
  onSelect?: () => void;
}

const TypeConnectCard: Component<BodyCardProps> = ({
  title = "Default Title",
  subtitle = "Default Subtitle",
  img = "default-icon",
  onSelect,
}) => {
  return (
    <>
      <style>{Styles}</style>
      <div class="__internal-card">
        <h1 class="__title">{title}</h1>
        <p class="__subtitle">{subtitle}</p>
        <img class="__img" src={img} alt={`image of ${title}`} />
        <button class="__action" onClick={onSelect}>
          {t["dns_general_select"]}
        </button>
      </div>
    </>
  );
};

export default TypeConnectCard;
